export const CHART_REASON_COLOR = {
    'Unknown': '#26aaff',
    'Price': '#a161fe',
    'Price + Shipping': '#fdba36',
    'Craped': '#d1a82c',
    'No 1P Offer': '#8f99a8',
    'Delivery Date': '#ff4953'
}

export const OPTIONS_FREQUENCY = [
    { label: 'Daily', value: 'date' },
    { label: 'Weekly (Mondays)', value: 'week' },
    { label: 'Execute Now', value: 'now' }
]

export const OPTIONS_INCLUDE_NEW_PRODUCTS = [
    { label: 'Include all products', value: 'No' },
    { label: 'Include only New products', value: 'Yes' }
]
